// extracted by mini-css-extract-plugin
module.exports = {"pintxo-dropdown":"Dropdown_pintxo-dropdown__ullSV"};